import React, { useContext } from 'react';
import styled from 'styled-components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { FlexSpace, LinkTab, LinksContainer } from '@ubeya/shared-web/components';
import { ORDER_SUMMARY_TABS } from './constants';

const Wrapper = styled(FlexSpace)`
  margin-bottom: 20px;
  z-index: 3;
`;

const OrdersSummaryModalTabs = ({ activeTab, setActiveTab, stats }) => {
  const { t } = useContext(ConfigContext);

  return (
    <Wrapper>
      <LinksContainer>
        {(Object.values(ORDER_SUMMARY_TABS) || []).map((tab) => (
          <LinkTab key={tab} isActive={activeTab === tab} onClick={() => setActiveTab(tab)}>
            {`${t(tab)}${
              stats ? ` (${tab === ORDER_SUMMARY_TABS.ACTIVE ? stats.numOfPending : stats.numOfPastPending})` : ''
            }`}
          </LinkTab>
        ))}
      </LinksContainer>
    </Wrapper>
  );
};

export default OrdersSummaryModalTabs;
